import { clsx } from 'clsx'
import { ReactNode } from 'react'
import css from './Button.module.scss'

type Props = {
  children?: ReactNode
  className?: string
  primary?: boolean
}

export function Button(props: Props) {
  const { children, primary } = props
  const type = primary ? css.primary : css.default
  const className = clsx(props.className, css.button, type)

  return <div className={className}>
    {children}
  </div>
}
